import { Observable } from "rxjs"
import { AccountTypeID } from "../../config/Constants"
import { ObservableFromFetch } from "../ObservableFromFetch"
import AutoFilterCompany from "../Companies/CompanyModel/AutoFilterCompany"

export function GetConsortiumCompaniesObservable(poolId: number): Observable<AutoFilterCompany[]> {
  const requestBody: string = JSON.stringify({
    AccountTypeID: AccountTypeID,
    PoolID: poolId
  })

  return ObservableFromFetch<AutoFilterCompany[]>("RandomTest/GetConsortiumAccounts", requestBody)
}

export function ValidateConsortiumCompanyObservable(poolId: number, accountID: number|string): Observable<string> {
  const requestBody: string = JSON.stringify({
    accountID: Number(accountID),
    poolID: poolId
  })

  return ObservableFromFetch<string>("RandomTest/ValidateConsortiumAccount", requestBody)
}